import React, { useEffect, useState } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import api from '../../api/api';
import ToastMessage from '../../utils/mui/righttoptoast';
import { showToast } from '../../reduxtoolkit/toastslice';
import { useDispatch } from 'react-redux';
import { getPracticeId } from '../../config/practice';

const Updatenote = ({ closeModal, task,trigger }) => {
  const [noteContent, setNoteContent] = useState(""); // State to track textarea input
  const practiseid = getPracticeId();
  const [openToast, setOpenToast] = useState(false);
        const [toastMessage, setToastMessage] = useState('');
  const dispatch=useDispatch()
        const [toastSeverity, setToastSeverity] = useState('success');
    const handleToastClose = () => {
    setOpenToast(false);
  };
  const handleChange = (e) => {
    setNoteContent(e.target.value); // Update the note content as user types
  };
  let user=localStorage.getItem('user')
  const handleSubmit = async () => {
    try {
      const response = await api.put(`/v1/${practiseid}/tasks/update_task_notes`, {
        orderid: task.id, // Assuming task has an 'id' field, you can adjust if it's named differently
        tasknotes: noteContent,
        loginuser: user, // You may want to get the logged-in user's info dynamically
      });
     if(response.status==200){
        // setToastSeverity('success')
        // setToastMessage(response.message)
        // setOpenToast(true)

         dispatch(
                  showToast({
                    message: response.message,
                    severity: "success",
                  }),
                );

    trigger(); // Waits 1.2 seconds before calling
    closeModal();

      }else{
           setToastSeverity('info')
        setToastMessage(response.message)
        setOpenToast(true)
      }
     
    } catch (error) {
       setToastSeverity('error')
        setToastMessage('Something Went Wrong')
        setOpenToast(true)
      console.error('Error adding note:', error);
    }
  };
  useEffect(()=>{

if(task?.order_notes){
  setNoteContent(task?.order_notes)
}

  },[task])
 
  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50"
      onClick={closeModal} // Close modal on clicking outside
    >
      <div
        className="bg-white w-[90%] md:w-[450px] rounded-xl relative flex flex-column"
        onClick={(e) => e.stopPropagation()} // Prevent closing when clicking inside the modal
      >
        <div className="flex px-4 py-2 justify-between w-full items-center border-b pt-3">
          <h2 className="text-lg font-inter">Note</h2>
          <button onClick={closeModal} className="p-2 rounded-full">
            <CloseIcon style={{ color: "#C7C7CB" }} />
          </button>
        </div>
        <div className="p-4">
          <div className="p-3">
            {/* <p className="text-start text-[15px] font-inter">Update Note</p> */}
            <textarea
              rows={6}
              className="border-2 border-gray-200 w-full rounded-2xl p-2"
              value={noteContent}
              onChange={handleChange} // Track user input in textarea
            />
          </div>
          <div className="flex items-center justify-center w-full">
            <button
              className="bg-[#50869A] px-12 font-inter py-2 rounded-3xl text-white"
              onClick={()=>handleSubmit()} // Call the handleSubmit function to send the note
            >
              Update Note
            </button>
          </div>
        </div>
      </div>
        <ToastMessage
                  message={toastMessage}
                  severity={toastSeverity}
                  open={openToast}
                  handleClose={handleToastClose}
                />
    </div>
  );
};

export default Updatenote;
